import EcoSpace from 'eco-design/base/eco-space';
import { useMemo } from 'react';
import { ShopifyCartItemType } from '@elem/compCommon/ShopifyShoppingCart/const';
import EcoAccessories2 from './eco-accessories2';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import useProductInfo from '@/utils/hooks/useProductInfo';

export default function Comp({ callback }: { callback?: (card: ShopifyCartItemType[]) => void }) {
    const { t } = useLang('theProduct.AccessoryA');
    const { locale = 'us' } = getLocal();

    const ids = [
        {
            productId: 7680679510177,
            variantId: 42959993110689,
        },
        {
            children: [
                {
                    productId: 14692437754223,
                    variantId: 51993313247599,
                    tab: t('item2_tab1'),
                    // lDisabled: true,
                    // soldOut: t('info_btn2'),
                    // lChildren: t('info_btn2'),
                },
                {
                    productId: 14692437754223,
                    variantId: 51993313280367,
                    tab: t('item2_tab2'),
                    // lDisabled: true,
                    // soldOut: t('info_btn2'),
                    // lChildren: t('info_btn2'),
                },
            ],
        },
        {
            children: [
                {
                    productId: 14692437852527,
                    variantId: 51892007108975,
                    tab: t('item3_tab1'),
                    // lDisabled: true,
                    // soldOut: t('info_btn2'),
                    // lChildren: t('info_btn2'),
                },
                {
                    productId: 14692437852527,
                    variantId: 51892007141743,
                    tab: t('item3_tab2'),
                    // soldOut: t('info_btn2'),
                    // lDisabled: true,
                    // lChildren: t('info_btn2'),
                },
                {
                    productId: 14692437852527,
                    variantId: 51892007174511,
                    tab: t('item3_tab3'),
                    // lDisabled: true,
                    // soldOut: t('info_btn2'),
                    // lChildren: t('info_btn2'),
                },
            ],
        },
        {
            productId: 14692437918063,
            variantId: 51841209270639,
            // lDisabled: true,
            // soldOut: t('info_btn2'),
            // lChildren: t('info_btn2'),
        },
        {
            productId: 14692438049135,
            variantId: 51841213759855,
            // lDisabled: true,
            // soldOut: t('info_btn2'),
            // lChildren: t('info_btn2'),
        },
        {
            productId: 14692438081903,
            variantId: 51841215005039,
            // lDisabled: true,
            // soldOut: t('info_btn2'),
            // lChildren: t('info_btn2'),
        },
    ];

    const list = useProductInfo(ids, {
        compareAtPrice: 'comparePrice',
        variantImg: 'pc',
    });

    const items = useMemo(() => {
        const formatItem = (data: any, idx1: number, tab?: string, idx2?: number) => {
            const title = data.skuTitle === 'Default Title' ? data.productTitle : data.skuTitle;
            return {
                tab,
                lChildren: t('info_btn'),
                title,
                // lDisabled: data.inventoryQuantity <= 0,
                desc: t(`item${idx1 + 1}_desc${idx2 !== undefined ? idx2 + 1 : ''}`),
                onClick() {
                    callback?.([
                        {
                            originalPrice: data.compareAtPrice,
                            discountPrice: data.price,
                            img: data.variantImg,
                            productImg: data.img,
                            title,
                            productId: String(data.productId),
                            variantId: String(data.variantId),
                            quantity: 1,
                            inventory: data.inventoryQuantity,
                        },
                    ]);
                },
                lDataLayer: {
                    event: 'uaEvent',
                    event_name: 'bundle_add_to_cart',
                    list_name: t('title'),
                    product_name: title,
                    price: data.price,
                    tag: 'none',
                    quantity: 1,
                    button_name: t('info_btn'),
                },
                priceSuffix: '（税込）',
                ...data,
            };
        };

        return list.map((i, idx) => {
            if (i.children) {
                return {
                    children: i.children.map((child, idx2) => {
                        return formatItem(child, idx, child.tab, idx2);
                    }),
                };
            } else {
                const data = list[idx];
                return formatItem(data, idx);
            }
        });
    }, [list]);

    const handleMediaClick = (item: any) => {
        window.open(`https://${locale}.ecoflow.com/products/${item.handle}?variantId=${item.variantId}`);
    };

    return (
        <div className={styles.comp}>
            <EcoSpace />
            <EcoAccessories2 title={t('title')} items={items} onClickImgVideo={locale === 'jp' ? handleMediaClick : undefined} className={styles.comp} />
        </div>
    );
}
